"use client";

import React from "react";
import { Toaster as Sonner } from "sonner";
import { withRef } from "@/lib/with-ref";
import type { ToasterElement, ToasterProps } from "./types";

const Toaster = withRef<ToasterElement, ToasterProps>((props, ref) => {
  return (
    <Sonner
      ref={ref}
      className="toaster group"
      toastOptions={{
        classNames: {
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground hover:bg-primary/80 shadow-lg",
          cancelButton: "group-[.toast]:bg-gold group-[.toast]:text-primary",
          description: "group-[.toast]:text-white",
          toast:
            "group toast group-[.toaster]:bg-foreground group-[.toaster]:text-white group-[.toaster]:border-border group-[.toaster]:shadow-lg",
        },
      }}
      {...props}
    />
  );
});

export default React.memo(Toaster);
